export enum actionTypes {
    SET_LOGIN_IN_PROCESS = 'AUTH:LOGIN_IN_PROCESS:SET',
    SET_SSO_ATTEMPTED = 'AUTH:SSO_ATTEMPTED:SET',
    SET_AUTO_LOGIN_COMPLETED = 'AUTH:AUTO_LOGIN_COMPLETED:SET',
    SET_LOGOUT_IN_PROCESS = 'AUTH:LOGOUT_IN_PROCESS:SET',
    SET_IS_LOGOUT_MANUAL = 'AUTH:IS_LOGOUT_MANUAL:SET',
    ADD_AFTER_CREDENTIALS_LOGIN_HOOK = 'AUTH:AFTER_CREDENTIALS_LOGIN_HOOK:ADD',
    ADD_BEFORE_REGISTRATION_HOOK = 'AUTH:BEFORE_REGISTRATION_HOOK:ADD'
}
